<template>
  <div>
    <div class="row">
      <div class="col">
        <h5>Abstract type selection</h5>
        <div>
          Please select the abstract type.
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="alert alert-info mb-1">
          <div class="row">
            <div class="col-1 d-flex">
              <icon :icon="['fad', 'exclamation']" class="my-auto fa-2x"/>
            </div>
            <div class="col">
              Please note that you <span class="text-danger">may not change the option later</span> in the
              abstract submission process.<br>
              If you would like to use a different option, you will have to create a new
              abstract.
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row mt-3">
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Artificial Intelligence and Computational Approaches</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(9)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Data Management</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(2)">Select</button>
          </div>
        </div>
      </div>
      
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">JACIE & Quality Management </h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(4)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Patient Advocacy & Outcomes</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(8)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Psychological Issues</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(6)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Pharmacology</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(7)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Health Economics & Tech Assessment</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(3)">Select</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'

export default {
  name: "AbstractType",
  data() {
    return {
      submitted: false,
    };
  },
  methods: {
    ...mapActions([
      'CREATE_ABSTRACT', 'UPDATE_REFERENCE'
    ]),
    newAbstract(type) {
      if (this.submitted === true) {
        return false;
      }
      this.submitted = true;
      let template = {
        "user_id": this.user.id,
        "type_id": type,
        "setting_submission_id": 2,
        "reference_number": this.getSettings(2).reference_number,
        "content": {},
        "status_id": 1
      };
      if (type === 2) {
        template['theme_id'] = 40;
      }
      if (type === 3) {
        template['theme_id'] = 45;
      }
      if (type === 4) {
        template['theme_id'] = 41;
      }
      if (type === 6) {
        template['theme_id'] = 43;
      }
      if (type === 7) {
        template['theme_id'] = 44;
      }
      if (type === 8) {
        template['theme_id'] = 42;
      }
      if (type === 9) {
        template['theme_id'] = 39;
      }

      this.CREATE_ABSTRACT(template).then((response) => {
        this.$noty.success('Save was successful');
        this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(2).id)
      }).catch((error) => {
        this.$noty.error('Save was <strong>not</strong> successful');
      });
    }
  },
  computed: {
    ...mapState([
      'wording', 'user'
    ]),
    ...mapGetters([
      'getSettings', 'getFirstCurrentPage'
    ]),
  },
}
</script>

<style scoped>

</style>
